import Box from "@/elements/Box";
import Typography from "@/elements/Typography";
import { Icon } from "@mui/material";
import { ComponentProps } from "react";
import { useTranslation } from "react-i18next";

function DispositivoStatus({
  type,
  status,
  controls = null,
  manuale = false,
  alarm = false,
}: {
  type: "power" | "connection";
  status: boolean;
  controls?: JSX.Element | null;
  manuale?: boolean | null;
  alarm?: boolean | null;
}) {
  const { t } = useTranslation();
  let icon: JSX.Element | null = null;
  let label: string | null = null;
  let statusColor: ComponentProps<typeof Typography>["color"];

  if (type === "power") {
    icon = <Icon>power_settings_news</Icon>;
    if (status) {
      label = t("dispositivoStatus.on");
    } else {
      label = t("dispositivoStatus.off");
    }
    if (manuale && label) {
      label = `${label} ${t("dispositivoStatus.manualeSuffix")}`;
    }
  } else if (type === "connection") {
    if (status) {
      icon = <Icon>cloud_queue</Icon>;
      label = t("dispositivoStatus.online");
    } else {
      icon = <Icon>cloud_off</Icon>;
      label = t("dispositivoStatus.offline");
    }
  }

  if (alarm) {
    statusColor = "warning";
  } else if (status) {
    statusColor = "success";
  } else {
    statusColor = "error";
  }

  return (
    <Box display="flex" flexDirection="row" alignItems="start">
      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        minWidth={130}
      >
        <Typography
          variant="h3"
          color={statusColor}
          display="flex"
          flexDirection="row"
          alignItems="center"
        >
          {icon}
        </Typography>

        <Typography variant="h6" ml={1} mr={2}>
          {label}
        </Typography>
      </Box>

      {controls}
    </Box>
  );
}

export default DispositivoStatus;
